var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublishIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15833 11.2584L11.85 14.575M11.8417 5.42502L6.15833 8.74169M16.5 4.16669C16.5 5.5474 15.3807 6.66669 14 6.66669C12.6193 6.66669 11.5 5.5474 11.5 4.16669C11.5 2.78598 12.6193 1.66669 14 1.66669C15.3807 1.66669 16.5 2.78598 16.5 4.16669ZM6.5 10C6.5 11.3807 5.38071 12.5 4 12.5C2.61929 12.5 1.5 11.3807 1.5 10C1.5 8.61931 2.61929 7.50002 4 7.50002C5.38071 7.50002 6.5 8.61931 6.5 10ZM16.5 15.8334C16.5 17.2141 15.3807 18.3334 14 18.3334C12.6193 18.3334 11.5 17.2141 11.5 15.8334C11.5 14.4526 12.6193 13.3334 14 13.3334C15.3807 13.3334 16.5 14.4526 16.5 15.8334Z",
    stroke: "#1E5BF5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishIcon);
export default __webpack_public_path__ + "static/media/publish-icon.970d43ac.svg";
export { ForwardRef as ReactComponent };